module.exports = __webpack_public_path__ + "img/3.8b696ff1.jpg";